import * as React from 'react'

import { store } from 'modules/calendar/lib/calendarLeavesContext'

export const useCalendarLeaves = () => {
  const context = React.useContext(store)

  if (!context) {
    throw new Error('CalendarLeavesContext has not been properly set')
  }

  return context
}
